/** @format */
import React, { FunctionComponent, useState, useEffect } from 'react'
import styled from 'styled-components'
import { Input, Icon, _$, Button } from '@king-design/react'

interface OwnProps {
  className?: string
  placeholder?: string
  defaultValue?: string
  value?: string
  prepend?: any
  disabled?: boolean
  width?: number | string
  onChange: (searchValue?: string) => void
}

const MonitorSearch: FunctionComponent<OwnProps> = ({
  className,
  placeholder,
  defaultValue,
  value,
  onChange,
  prepend,
  width,
  disabled
}) => {
  const [inputValue, setInputValue] = useState<string>(defaultValue || value || '')

  useEffect(() => {
    setInputValue(value)
  }, [value])

  return (
    <Input
      className={className}
      disabled={disabled}
      clearable
      width={width}
      value={inputValue}
      stackClearIcon
      onClear={() => {
        setInputValue('')
        onChange && onChange('')
      }}
      onKeyUp={e => {
        if (e.keyCode === 13) {
          onChange && onChange(inputValue)
        }
      }}
      onChangeValue={value => {
        setInputValue(value)
      }}
      placeholder={placeholder ? _$(placeholder) : _$('输入查询')}
      slotPrepend={prepend || null}
      slotAppend={
        <Button
          icon
          type="none"
          onClick={() => {
            onChange && onChange(inputValue)
          }}
        >
          <Icon className="k-icon-search" />
        </Button>
      }
    />
  )
}

export default styled(MonitorSearch)``
